<template>
  <CCard>
    <CCardHeader class="d-flex justify-content-end">
      <h2 class="text-uppercase font-weight-bold mb-0">
        List of Categories <span
          v-c-tooltip="'These categories will be used for the End User Dashboard page in the order that set on this page'"
          class="text-secondary"
        ><i
          class="far fa-question-circle"
        /></span>
      </h2>
      <CButton
        class="ml-auto"
        color="primary"
        @click="createClass"
      >
        Add New
      </CButton>
    </CCardHeader>
    <CCardBody>
      <div class="position-relative table-responsive">
        <table class="table">
          <thead>
            <tr>
              <th>#</th>
              <th>Name</th>
              <th>Actions</th>
            </tr>
          </thead>
          <draggable
            v-model="data"
            item-key="id"
            tag="tbody"
            @end="saveOrder()"
          >
            <template #item="{element}">
              <tr>
                <td scope="row">
                  {{ element.order }}
                </td>
                <td>{{ element.name }}</td>
                <td style="width: 20%">
                  <div class="d-flex flex-nowrap align-items-center">
                    <CButton
                      v-if="element.visible"
                      size="sm"
                      color="warning"
                      class="text-white mr-2"
                      @click="askHide(element)"
                    >
                      Hide
                    </CButton>
                    <CButton
                      v-if="!element.visible"
                      size="sm"
                      color="success"
                      class="text-white mr-2"
                      @click="askShow(element)"
                    >
                      Show
                    </CButton>
                    <CButton
                      size="sm"
                      color="warning"
                      class="text-white mr-2"
                      @click="editClass(element.id)"
                    >
                      Edit
                    </CButton>
                    <CButton
                      size="sm"
                      color="danger"
                      class="text-white"
                      @click="deleteClass(element.id)"
                    >
                      Delete
                    </CButton>

                    <span class="mx-3">
                      <i class="fas fa-arrows-alt" />
                    </span>
                  </div>
                </td>
              </tr>
            </template>
          </draggable>
        </table>
        <CElementCover
          v-if="loading"
          :boundaries="[
            { sides: ['top'], query: 'td' },
            { sides: ['bottom'], query: 'tbody' }
          ]"
        />
      </div>
    </CCardBody>
    <delete-confirm-modal
      ref="delete_modal"
      @confirmed="confirmDelete"
    />
    <default-confirm-action-modal
      ref="show_modal"
      @confirmed="show"
    />
    <default-confirm-action-modal
      ref="hide_modal"
      @confirmed="hide"
    />
  </CCard>
</template>

<script>
import externalTable from "@/mixins/externalTable";
import DeleteConfirmModal from "@/views/sessions/DeleteConfirmModal";
import draggable from 'vuedraggable'
import DefaultConfirmActionModal from "@/components/DefaultConfirmActionModal";

export default {
  name: "ClassCategories",
  components: {DefaultConfirmActionModal, DeleteConfirmModal, draggable},
  mixins: [externalTable],
  data() {
    return {
      url: '/categories'
    }
  },
  computed: {},
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.loading = true;
      this.$http.get(this.url, {params: {...this.options, filters: this.filters}}).then(({data}) => {
        this.data = data.data;
      }).finally(() => {
        this.loading = false;
      });
    },
    createClass() {
      this.$router.push({name: 'New Category'});
    },
    editClass(id) {
      this.$router.push({name: 'Edit Category', params: {id: id}});
    },
    deleteClass(id) {
      this.$refs.delete_modal.open(id);
    },
    confirmDelete(id) {
      this.$http.delete('/categories/' + id + '').then(() => {
        this.$toast.success('Deleted!');
        this.fetchData()
      })
    },
    askShow(item) {
      this.$refs.show_modal.open(item)
    },
    askHide(item) {
      this.$refs.hide_modal.open(item)
    },
    hide(item) {
      this.$http.put('/categories/' + item.id + '/hide').then(() => {
        this.$toast.success('Updated!');
        this.fetchData()
      })
    },
    show(item) {
      this.$http.put('/categories/' + item.id + '/show').then(() => {
        this.$toast.success('Updated!');
        this.fetchData()
      })
    },
    saveOrder() {
      this.$http.put('/categories/order', {
        categories: this.data.map(item => {
          return item.id
        })
      }).then(() => {
        this.$toast.success('Order Changed!');
        this.fetchData()
      })
    }
  }
}
</script>

<style scoped>
.status-badge {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: inline-block;
}
</style>